import { CircularProgress, Stack, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { SystemChargeTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";
import DeleteIcon from '@mui/icons-material/Delete';
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const SystemChargeTable: React.FC<SystemChargeTablePropsType> = ({ rows, handleItemClick, selectedSystemChargeId }) => {
    const systemChargeTableHeaders = ["Charge Name", "Charge Mode", "GL Account", "Charge Type", "Product", "Amount", "Action Required", "Allow Override", "Action"];

    return (
        <BaseTable headers={systemChargeTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.name}</TableCell>
                            <TableCell>{row?.mode?.charAt(0).toUpperCase() + row?.mode?.slice(1).toLowerCase()}</TableCell>
                            <TableCell>
                                {row?.glAccount?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </TableCell>
                            <TableCell>{row?.type?.charAt(0).toUpperCase() + row?.type.slice(1).toLowerCase()}</TableCell>
                            <TableCell>{row?.linkedProduct}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                            <TableCell>{row?.action?.charAt(0).toUpperCase() + row?.action?.slice(1).toLowerCase() || "N/A"}</TableCell>
                            <TableCell>{row?.allowOverride?.charAt(0).toUpperCase() + row?.allowOverride?.slice(1).toLowerCase()}</TableCell>
                            <TableCell>
                                <Stack direction="row" gap="calc(var(--flex-gap)/4)">
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick(e, row.id, "edit")}
                                    >
                                        Edit
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick?.(e, { systemChargeId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {selectedSystemChargeId !== null && selectedSystemChargeId === row.id ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
